import Typography from "@mui/material/Typography";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import Button from "@mui/material/Button";
import { LoadingListEntityProfile, PaginationList } from "Explore/Components";
import { IconPack } from "Explore/Config/Icons";
import { numberRegex } from "Explore/Utils/numberRegex";
import { Dropdown, Empty, Tag } from "antd";
import styles from "./FacultyPublications.module.scss";

import { CheckCircleTwoTone } from "@ant-design/icons";
import { getAuthorPublicationsByID } from "Explore/Services/Author";
import { Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useAuth from "Hooks/useAuth";
import LoginRequiredSection from "Explore/Components/LoginRequired";
const Publication = ({ publication }) => {
  const checkedCircleColor =
    publication.verified === true ? "#52c41a" : "lightgray";
  const toolTipText =
    publication.verified === true ? "Verified" : "Not yet verified";
  return (
    <div className={styles["publication"]}>
      <div className={styles["title"]}>
        <span>
          <Tooltip title={toolTipText}>
            <CheckCircleTwoTone twoToneColor={checkedCircleColor} />
          </Tooltip>
          &nbsp;
        </span>
        <span className={styles["paper-title"]}>
          <a href={publication.doi} target="_blank" rel="noreferrer">
            {publication.title}.{" "}
          </a>
        </span>
        <span className={styles["venue"]}>
          <i>{publication.venue} </i>
        </span>
        <span>{publication.year > 0 ? `(${publication.year})` : ""}</span>
      </div>
      {/* <a href={publication.doi} target="_blank">{publication.doi}</a> */}
      <div className={styles["coauthors"]}>
        {publication.coauthors.map((item, index) => {
          return <span key={index}>{item.name}</span>;
        })}
      </div>
      <div className={styles["tags"]}>
        {publication.keywords.map((item, index) => {
          return (
            <Tag
              key={index}
              color="var(--light-blue)"
              style={{ cursor: "pointer" }}
            >
              {item.id}
            </Tag>
          );
        })}
      </div>
      <div className={styles["action"]}>
        {false && (
          <Button
            style={{
              backgroundColor: "white",
              color: "#b45f06",
              borderRadius: 10,
              height: 25,
              paddingLeft: 0,
              textAlign: "left",
              textTransform: "none",
              marginRight: "10px",
            }}
          >
            <FormatQuoteIcon />
            <Typography align={"left"} style={{ fontSize: 12 }}>
              {numberRegex(parseFloat(publication["citation_count"]))}
            </Typography>
          </Button>
        )}
      </div>
    </div>
  );
};
const FacultyPublications = ({
  tab,
  verified,
  setVerified,
  selectedKeywords,
  sliderValue,
}) => {
  const { isAuthLoading, userTypeConfig } = useAuth({
    entityType: "FACULTY",
  });
  const faculty_id = useLocation().pathname.split("/")[3];
  const [data, setData] = useState({ data: [], isLoading: true });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    hasMore: true,
  });
  const [showLoginSection, setShowLoginSection] = useState(false);

  const items = [
    {
      label: (
        <div
          style={{ width: "350px", display: "flex", flexDirection: "column" }}
          onClick={() => {
            setVerified(true);
          }}
        >
          <p style={{ fontWeight: "600" }}>Verified</p>
          <p
            style={{
              fontSize: "13px",
              color: "var(--dark-grey)",
            }}
          >
            Only display publications that have been verified as belonging to
            this author.
          </p>
        </div>
      ),
      key: "0",
    },
    {
      label: (
        <div
          style={{ width: "350px", display: "flex", flexDirection: "column" }}
          onClick={() => {
            setVerified(false);
          }}
        >
          <p style={{ fontWeight: "600" }}>All</p>
          <p
            style={{
              fontSize: "13px",
              color: "var(--dark-grey)",
            }}
          >
            Display all found publications, including those not yet verified.
          </p>
        </div>
      ),
      key: "1",
    },
  ];
  useEffect(() => {
    if (tab === "publications" && !isAuthLoading) {
      setData({ ...data, isLoading: true });
      getAuthorPublicationsByID(
        faculty_id,
        pagination.page - 1,
        pagination.rowsPerPage,
        sliderValue,
        selectedKeywords,
        verified,
        (res) => {
          setData({ data: res.publications, isLoading: false });
          if (res.total >= 0) {
            setPagination({ ...pagination, totalRows: res.total });
          }
        },
        (err) => {
          if (err?.response?.status === 401) {
            setShowLoginSection(true);
          }
          setData({ data: [], isLoading: false });
        }
      );
    }
  }, [
    faculty_id,
    selectedKeywords,
    sliderValue,
    pagination.page,
    pagination.rowsPerPage,
    tab,
    verified,
    isAuthLoading,
  ]);
  return (
    <div className={styles["faculty-publications"]}>
      <Dropdown
        menu={{
          items,
        }}
        placement="top"
        arrow={{
          pointAtCenter: true,
        }}
        trigger={["click"]}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "10px",
            cursor: "pointer",
            width: "fit-content",
          }}
        >
          <p style={{ color: "var(--dark-grey)", fontWeight: "600" }}>
            {verified ? "Verified" : "All"}
          </p>
          {IconPack.dropDownArrow}
        </div>
      </Dropdown>
      <LoadingListEntityProfile
        isLoading={data.isLoading}
        component={
          data.data.length > 0 ? (
            data?.data.map((item, index) => {
              return <Publication publication={item} key={index} />;
            })
          ) : showLoginSection ? (
            <LoginRequiredSection />
          ) : (
            <Empty description="No Publication Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={true}
      />
      <PaginationList
        pagination={pagination}
        setPagination={setPagination}
        sizeChanger={userTypeConfig.ui_components.pageSizeChanger}
      />
    </div>
  );
};

export default FacultyPublications;
